"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const Chip_1 = __importDefault(require("@mui/material/Chip"));
const BetaChipModal_1 = __importDefault(require("./BetaChipModal"));
const StyledChip = (0, styled_components_1.default)(Chip_1.default) `
  color: ${({ theme }) => theme.palette.common.white};
  background-color: ${({ theme }) => theme.palette.primary.main};
  font-weight: bold;
  font-size: 10px;
  height: auto;
  letter-spacing: 0.5px;
  margin-bottom: 5px;

  > span {
    padding: 6px 12px;
  }

  &.MuiChip-clickable:hover {
    background-color: ${({ theme }) => theme.palette.primary.dark};
  }
`;
const BetaChip = ({ ModalContent, onClick, ...rest }) => {
    const [showModal, setShowModal] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StyledChip, { label: "\u2728 BETA", onClick: ModalContent ? () => setShowModal(true) : onClick, ...rest }), ModalContent && ((0, jsx_runtime_1.jsx)(BetaChipModal_1.default, { Content: ModalContent, onClose: () => setShowModal(false), open: showModal }))] }));
};
exports.default = BetaChip;
//# sourceMappingURL=index.js.map